/**
 * "The session lapsed" as a module-level fact.
 *
 * A lapse is not a logout: the token is dead, but the React tree stays mounted
 * behind `ReauthDialog` so the user does not lose unsaved work. `AuthContext`
 * owns the state; this module exists because the two places that *notice* a
 * lapse first — the axios interceptors and the chat websocket — are not React
 * and cannot read a context.
 *
 * Read it to answer "may new work start?". `isAuthenticated` answers a
 * different question ("may this tree stay mounted?") and stays true during a
 * lapse; conflating the two is what unmounts the editor the dialog was added
 * to protect.
 */
let lapsed = false;

export function isSessionLapsed(): boolean {
  return lapsed;
}

/** Set by `AuthContext` only. */
export function setSessionLapsedFlag(value: boolean): void {
  lapsed = value;
}
